import { useTheme } from "styled-components";

import { passwordIcon, phoneIcon, taxIDIcon } from "./defaultIcons";
import fnrInputTypes from "./fnrInputTypes";

const useIcon = ({ iconArg, type }) => {
  if (iconArg === false) return iconArg;
  switch (type) {
    case fnrInputTypes.phone:
      return phoneIcon;
    case fnrInputTypes.taxid:
      return taxIDIcon;
    case fnrInputTypes.password:
      return passwordIcon;
    default:
      return iconArg;
  }
};

const useIconColor = ({ iconColorArg, type }) => {
  const { colors, palette } = useTheme();
  if (iconColorArg) return iconColorArg;
  switch (type) {
    case fnrInputTypes.phone:
    case fnrInputTypes.taxid:
    case fnrInputTypes.password:
      return palette.fnBlue;
    default:
      return iconColorArg || colors.fnBlue;
  }
};

export { useIcon, useIconColor };
